import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52e905fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-search el-input__icon fas" }, null, -1))
const _hoisted_2 = ["title"]
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_page_header_component = _resolveComponent("page-header-component")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_parameter_form = _resolveComponent("parameter-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, null, {
    header: _withCtx(() => [
      _createVNode(_component_page_header_component, {
        title: _ctx.$t('label.parametersList')
      }, {
        right: _withCtx(() => [
          _createVNode(_component_el_input, {
            class: "search",
            modelValue: _ctx.query,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search()))
          }, {
            prefix: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["title"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_table, {
        data: _ctx.parametersList,
        stripe: "",
        "row-class-name": _ctx.tableRowClassName,
        style: {"width":"100%"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: _ctx.$t('label.name'),
            width: "280"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "code",
            label: _ctx.$t('label.code'),
            align: "center",
            "header-align": "center"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "abbreviation",
            label: _ctx.$t('label.abbreviation'),
            align: "center",
            "header-align": "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.abbreviation ? scope.row.abbreviation : "-"), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "unit",
            label: _ctx.$t('label.units'),
            align: "center",
            "header-align": "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.unit ? scope.row.unit : "-"), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "type",
            label: _ctx.$t('label.type'),
            align: "center",
            "header-align": "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.type ? _ctx.$t(`parameterType.${scope.row.type.toLowerCase()}`) : "-"), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "subtype",
            label: _ctx.$t('label.subtype'),
            align: "center",
            "header-align": "center"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.subtype ? _ctx.$t(`parameterType.${scope.row.subtype.toLowerCase()}`) : "-"), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "active",
            label: _ctx.$t('label.status')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_tag, {
                type: scope.row.active ? 'success' : 'danger'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(scope.row.active ? "status.active" : "status.no-active")), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: _ctx.$t('label.operations')
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "default",
                size: "small",
                onClick: ($event: any) => (_ctx.openParameterFormDialog(scope.row))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("em", {
                    class: "el-icon el-icon-edit fas",
                    title: _ctx.$t('btn.edit')
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1032, ["onClick"]),
              (!scope.row.active)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "success",
                    size: "small",
                    onClick: ($event: any) => (_ctx.confirmActivateItem(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("em", {
                        class: "el-icon el-icon-check fas",
                        title: _ctx.$t('btn.activate')
                      }, null, 8, _hoisted_3)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              (scope.row.active)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "danger",
                    size: "small",
                    onClick: ($event: any) => (_ctx.confirmDeactivateItem(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("em", {
                        class: "el-icon el-icon-times fas",
                        title: _ctx.$t('btn.deactivate')
                      }, null, 8, _hoisted_4)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data", "row-class-name"]),
      _createVNode(_component_el_pagination, {
        class: "app-table",
        layout: "total, sizes, prev, pager, next, jumper",
        currentPage: _ctx.currentPage,
        "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentPage) = $event)),
        "page-sizes": [10, 20, 50, 100],
        onSizeChange: _ctx.changePaginationSize,
        onCurrentChange: _ctx.changePaginationPage,
        "page-size": _ctx.rowPerPage,
        total: _ctx.totalRows
      }, null, 8, ["currentPage", "onSizeChange", "onCurrentChange", "page-size", "total"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showParameterForm,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showParameterForm) = $event)),
        title: _ctx.$t('label.parameterNew'),
        width: "50%",
        "destroy-on-close": "",
        "custom-class": "app-form"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeParameterFormDialog()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveParameter()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_parameter_form, {
            ref: "paramForm",
            "parameter-data": _ctx.parameterSelected
          }, null, 8, ["parameter-data"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _: 1
  }))
}